import { render, staticRenderFns } from "./ProvidersAdditionalFees.vue?vue&type=template&id=80a27078"
import script from "./ProvidersAdditionalFees.vue?vue&type=script&lang=js"
export * from "./ProvidersAdditionalFees.vue?vue&type=script&lang=js"
import style0 from "./ProvidersAdditionalFees.vue?vue&type=style&index=0&id=80a27078&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports